import { createFileRoute, useNavigate } from '@tanstack/react-router';
import * as React from 'react';
import { z } from 'zod';
import PermissionsService, { PERMISSION_COST_CENTERS } from '../../Services/PermissionsService';
import { requirePermission } from '../../router/RouteGuardsService';
import CostCentersForm from '../../components/CostCenters/Form';
import { URL_CODEBOOKS, URL_COST_CENTERS } from '../../router/constants';

const editCostCenterSearchSchema = z.object({
  customerId: z.coerce.number().optional(),
});

export const Route = createFileRoute('/_authenticated/system_settings/cost-centers/edit/$id')({
  validateSearch: editCostCenterSearchSchema,
  beforeLoad: async ({ context }) => {
    await requirePermission(PERMISSION_COST_CENTERS, ['update'], '/unauthorized', context);
    return {
      ...context,
      documentTitle: {
        main: 'table.detail',
        suffix: 'tab.cost-centers',
      },
    };
  },
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: EditCostCenterRoute,
});

function EditCostCenterRoute() {
  const { id } = Route.useParams();
  const search = Route.useSearch();
  const navigate = useNavigate();
  const customerId = search.customerId ?? null;

  const handleClose = React.useCallback(() => {
    navigate({ to: `${URL_CODEBOOKS}${URL_COST_CENTERS}` });
  }, [navigate]);

  return <CostCentersForm id={Number(id)} customerId={customerId} handleClose={handleClose} />;
}
